var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSimpleCaret(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.1743 3.62918L8 10.0699L1.82573 3.62918C1.33887 3.06912 0.852005 3.05745 0.365146 3.59418C-0.121715 4.1309 -0.121715 4.65596 0.365146 5.16935L7.26971 12.4502C7.44675 12.6835 7.69018 12.8002 8 12.8002C8.30982 12.8002 8.55325 12.6835 8.73029 12.4502L15.6349 5.16935C16.1217 4.65596 16.1217 4.1309 15.6349 3.59418C15.148 3.05745 14.6611 3.06912 14.1743 3.62918Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSimpleCaret);
export default __webpack_public_path__ + "static/media/simple-caret.056157fd74038acb58d659aebea06c68.svg";
export { ForwardRef as ReactComponent };